import type { ReactNode } from 'react';
import { Box } from '../../../Core';

/** Shared full-height flex layout for workflow drawer panels. */
export function WorkflowDrawerLayout({ children }: { children: ReactNode }) {
  return (
    <Box h="100%" minHeight={0} overflow="hidden" display="flex" flexDirection="column" background="backgroundDrawer">
      {children}
    </Box>
  );
}
